import { Avatar } from '@material-ui/core';
import React from 'react';

const UpcomingMCards = (props) =>
{
	const { meetingsList, setSelectedMeeting, selectedMeeting } = props;

	function getTimeFromMilliseconds(milliseconds)
	{
		const date = new Date(milliseconds);

		return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
	}

	function formatTime(minutes)
	{
		if (minutes < 60)
		{
			return `${minutes}m`;
		}
		else
		{
			const hours = Math.floor(minutes / 60);
			const remainingMinutes = minutes % 60;

			return `${hours.toString().padStart(2, '0')}h ${remainingMinutes.toString().padStart(2, '0')}m`;
		}
	}

	return (
		<div className='flexMinHeightCol pdngXS scrollYAuto'>
			{/* No need for console.log inside JSX */}
			{meetingsList && meetingsList.map((item, index) => (
				<div className={`flexRow pdngSM brdrRadiusLSM mrgnVXS pointer ${(selectedMeeting ? selectedMeeting._id === item._id : index === 0) ? 'mtngCardBg' : 'mtngIconsBg'}`} key={index} onClick={() => setSelectedMeeting(item)}>
					<div className='flexAutoRow'>
						{/* <div className='brdrRadius50'> */}
						{console.log('itemmmmmmm', item)}
						<Avatar className='avatarIcon' src={item?.extra?.picture ? item?.extra?.picture : null}>{item?.extra?.name?.[0]?.toUpperCase()}</Avatar>
						{/* Ensure 'item.img' is available before accessing it */}
						{/* {item.img && <img src={item.img} alt='profile' className='brdrRadius50' />} */}
					</div>
					{/* </div> */}
					<div className='flexMinWidthCol pdngHSM'>
						<span className='whiteLightTxt ellipsisTxt'>{item.meetingName}</span>
						{/* Ensure 'item.startTimeUTC' is available before accessing it */}
						{item.startTimeUTC && <span className='graytextcolor'>{getTimeFromMilliseconds(item.startTimeUTC)}, {formatTime(item?.duration)}</span>}
						{/* Ensure 'item.extra.name' is available before accessing it */}
						{item.extra && item.extra.name && <span className='graytextcolor capitalizeTxt'>{item.extra.name}</span>}
					</div>
				</div>
			))}
		</div>
	);
};

export default UpcomingMCards;
